<template>
  <div>
    <Tabs type="card">
      <TabPane label="个人信息">
        <infoPerson></infoPerson>
      </TabPane>
      <TabPane label="家庭信息">
        <infoHome></infoHome>
      </TabPane>
      <TabPane label="教育信息">
        <infoEducation></infoEducation>
      </TabPane>
      <TabPane label="账号信息">
        <infoAccount></infoAccount>
      </TabPane>
    </Tabs>
  </div>
</template>


<script>
import infoAccount from "./info_account.vue";
import infoEducation from "./info_education.vue";
import infoHome from "./info_home.vue";
import infoPerson from "./info_person.vue";
export default {
  components: {
    infoAccount,
    infoEducation,
    infoHome,
    infoPerson,
  },
};
</script>